<template>
    <!-- 팝업 -->
    <div class="pop_up_layer find_account" style="display: block" @click="closeModal"></div>
    <div class="pop_up pop_detail" id="find_account" style="display: block; max-width: 800px">
        <button class="close_btn" @click="closeModal">
            <img src="img/close.png" alt="닫기" />
        </button>

        <template style="display: block">
            <div class="pop_tit">
                <p>{{ state.data.writer?.name }} 상담원의 요청</p>
            </div>

            <div class="content_wrap">
                <ul>
                    <li>
                        <span>요청일</span>
                        <p>{{ CommonUtils.dateFormat(state.data.createDate, "-", true) }}</p>
                    </li>

                    <template v-if="state.data.type === 1">
                        <li>
                            <span>연번</span>
                            <p>{{ state.data.clientVO.number }}</p>
                        </li>

                        <li>
                            <span>성매매 유형</span>
                            <p>{{ state.data.clientVO.type }}</p>
                        </li>
                    </template>

                    <template v-if="state.data.type === 2">
                        <li>
                            <span>상담 제목</span>
                            <p>{{ state.data.counselVO.title }}</p>
                        </li>

                        <li>
                            <span>조취 결과</span>
                            <p>{{ state.data.counselVO.result }}</p>
                        </li>
                    </template>

                    <li>
                        <span>구분</span>
                        <p v-text="state.data.strGubun"></p>
                    </li>

                    <li>
                        <span>요청 내용</span>
                        <textarea readonly v-text="state.data.reason"></textarea>
                    </li>

                    <li>
                        <span>반려 사유</span>
                        <textarea v-model="state.data.rejectReason"></textarea>
                    </li>
                </ul>

                <div class="btn_wrap">
                    <template v-if="state.data.state < 3">
                        <button class="submit_btn" @click="confirm">승인</button>
                        <button class="submit_btn _gray" @click="reject">반려</button>
                    </template>
                    <template v-else-if="state.data.state === 3">
                        <button class="submit_btn" @click="complete">처리 완료</button>
                    </template>
                </div>
            </div>
        </template>
    </div>
    <!-- 팝업 -->

    <ModalDefault
        v-if="state.isShowModal"
        :type="state.modalTab"
        :title="state.modalTitle"
        :content="state.modalContent"
        :gubun="state.gubun"
        @close="state.isShowModal = false"
        @callback="callbackModal"
    ></ModalDefault>
</template>
<script lang="ts" config>
    import { reactive, onMounted, onUnmounted, watch, CommonUtils, types, apiService, ModalDefault, getMessageByCode } from "@/BaseComponent";

    export default {
        props: {
            idx: {
                type: Number,
                default: 0,
            },
        },
        emits: ["close", "callback"],
        components: { ModalDefault },
        setup(props: any, { emit }: any) {
            const state = reactive({
                data: {
                    type: 1 as 1 | 2,
                    writer: {} as any,
                    clientVO: {} as any,
                    counselVO: {} as any,
                } as types.accessRequest.AccessRequestVOForApi,

                idx: 0 as number,

                isShowModal: false as boolean,
                modalTab: -1 as number,
                modalIsResult: false as boolean,
                modalTitle: "alert" as string,
                modalContent: "" as string,

                gubun: 1 as 1 | 2 | 4, // 1: confirm, 2: reject, 4: complete
            });

            onMounted(() => {
                state.idx = props.idx;
                detail();

                document.body.style.overflow = "hidden";
            });

            onUnmounted(() => {
                document.body.style.overflow = "";
            });

            watch(props, () => {
                state.idx = props.idx;

                detail();
            });

            const closeModal = () => {
                emit("close");
            };

            const callbackModal = (param: any) => {
                if (param.action === "confirm") {
                    save(param.gubun);
                } else if (param.action === "callback") {
                    emit("callback");
                }
            };

            const detail = async () => {
                const res = await apiService.accessRequest.detail(state.idx);

                if (res.returnCode === 0 && res.data) {
                    state.data = res.data;
                } else {
                    console.error(res.description);
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = getMessageByCode(res.returnCode);
                    state.isShowModal = true;
                }
            };

            const save = async (value: 1 | 2 | 4) => {
                const param: types.accessRequest.ReqAccessRequestForProcess = {
                    state: value,
                    rejectReason: state.data.rejectReason,
                };
                const res = await apiService.accessRequest.modify(state.idx, param);

                if (res.returnCode === 0) {
                    state.modalTab = 3;
                    state.modalTitle = "알림";
                    state.modalContent = "처리되었습니다.";
                    state.isShowModal = true;
                } else {
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = getMessageByCode(res.returnCode);
                    state.isShowModal = true;
                }
            };

            const confirm = () => {
                state.modalTab = 1;
                state.modalTitle = "알림";
                state.modalContent = "정말 승인하시겠습니까?";
                state.isShowModal = true;
                state.gubun = 1;
            };
            const reject = () => {
                state.modalTab = 1;
                state.modalTitle = "알림";
                state.modalContent = "정말 반려하시겠습니까?";
                state.isShowModal = true;
                state.gubun = 2;
            };
            const complete = () => {
                state.modalTab = 1;
                state.modalTitle = "알림";
                state.modalContent = "정말 처리 완료하시겠습니까?";
                state.isShowModal = true;
                state.gubun = 4;
            };

            return { state, closeModal, callbackModal, confirm, reject, complete, CommonUtils };
        },
    };
</script>

<style scoped>
    .content_wrap {
        margin-top: 20px;
    }
    .content_wrap ul li {
        display: flex;
        margin-bottom: 20px;
        align-items: center;
    }
    .content_wrap ul li > span {
        min-width: 110px;
        margin-right: 10px;
        text-align: left;

        font-family: Noto Sans KR;
        font-weight: 500;
        font-style: Medium;
        font-size: 16px;

        line-height: 100%;
        letter-spacing: 0%;

        color: #252525;
    }

    textarea {
        width: 100%;
    }
</style>
